$primary-green: #81ba43;
$secondary-green: #7fb02f;

$gray-900: #111827;
$gray-700: #374151;
$gray-500: #6b7280;
$gray-300: #d1d5db;
$gray-200: #e5e7eb;
$gray-100: #f3f4f6;

$red-600: #b91c1c;
$red-100: #fee2e2;
$red-200: #fecaca;

$amber-600: #b45309;
$amber-100: #fef3c7;
$amber-200: #fde68a;

$blue-600: #2563eb;
$blue-100: #dbeafe;
$blue-200: #bfdbfe;

$purple-600: #9333ea;
$purple-100: #f3e8ff;
$purple-200: #e9d5ff;

.badge {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	gap: 0.375rem;

	padding: 0.15rem 0.5rem;
	border-radius: 0.5rem;
	border: 1px solid transparent;
	background: #fff;
	color: #111827;

	font-weight: 600;
	font-size: 0.75rem;
	line-height: 1;
	white-space: nowrap;
	user-select: none;
	text-decoration: none;

	transition:
		background-color 0.15s ease,
		color 0.15s ease,
		border-color 0.15s ease,
		box-shadow 0.15s ease;
}

.badge:focus-visible {
	outline: 0;
	box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.15);
}

.label {
	line-height: 1;
}

.icon {
	display: grid;
	place-items: center;
	width: 16px;
	height: 16px;
}

.dot {
	width: 8px;
	height: 8px;
	border-radius: 9999px;
	background: currentColor;
	flex: 0 0 auto;
}

.sm {
	padding: 0.125rem 0.4rem;
	font-size: 0.7rem;
}
.md {
	padding: 0.15rem 0.5rem;
	font-size: 0.75rem;
}
.lg {
	padding: 0.25rem 0.65rem;
	font-size: 0.85rem;
}

.pill {
	border-radius: 9999px;
}
.interactive {
	cursor: pointer;
}
.interactive:hover {
	filter: brightness(0.98);
}

.neutral {
	background: $gray-100;
	color: $gray-700;
	border-color: $gray-200;
}

.primary {
	background: rgba($secondary-green, 0.15);
	color: $secondary-green;
	border-color: rgba($secondary-green, 0.35);
}

.success {
	background: rgba($primary-green, 0.15);
	color: $primary-green;
	border-color: rgba($primary-green, 0.35);
}

.warning {
	background: $amber-100;
	color: $amber-600;
	border-color: $amber-200;
}

.danger {
	background: $red-100;
	color: $red-600;
	border-color: $red-200;
}

.info {
	background: $blue-100;
	color: $blue-600;
	border-color: $blue-200;
}

.dark {
	background: $gray-900;
	color: #fff;
	border-color: $gray-700;
}

.outline {
	background: transparent;
	color: $gray-700;
	border-color: $gray-300;
}

.pending {
	background: rgba($purple-600, 0.15);
	color: $purple-600;
	border-color: rgba($purple-600, 0.35);
}
